const hamburger = document.querySelector('.hamburger-icon');
const adherentBtnMobile = document.querySelector('.btn-adherent-responsive');
const mainNav = document.querySelector('.nav-responsive');
const mainNavItemsWithChildren = document.querySelectorAll('#menu-primary_mobile li.menu-item-has-children > a');
const bodyElement = document.querySelector('body');
const firstUl = document.querySelector('#menu-primary_mobile');
const returnBtn = document.querySelector('.responsive-header-wrapper .mobile-return-btn');
const searchForm = document.querySelector('.responsive-header-wrapper .searchform');
const openedMenuAdherentLink = document.querySelector('.opened-mobile-menu-adherent');

hamburger.onclick = function() {

  mainNav.classList.toggle('show-menu');
  this.querySelector('.closed').classList.toggle('clicked');
  this.querySelector('.opened').classList.toggle('clicked');
  openedMenuAdherentLink.classList.toggle('show');
  adherentBtnMobile.classList.toggle('show-menu');
  bodyElement.classList.toggle('no-scroll');

  mainNavItemsWithChildren.forEach(element => {
    element.onclick = function() {
     
      openedMenuAdherentLink.classList.contains('show') && openedMenuAdherentLink.classList.remove('show')

      const subMenu = this.parentNode.querySelector('ul.sub-menu');
      subMenu.classList.add('show-mobile-sub-menu')
      returnBtn.classList.add('show');
      searchForm.classList.add('hide');
      subMenu.querySelectorAll('ul.sub-menu').forEach(el => el.classList.add('show-mobile-sub-menu'))

      returnBtn.onclick = () => {

        subMenu.classList.contains('show-mobile-sub-menu') && subMenu.classList.remove('show-mobile-sub-menu')

        if (firstUl == this.parentNode.parentNode) {
          returnBtn.classList.remove('show');
          searchForm.classList.remove('hide');
          !openedMenuAdherentLink.classList.contains('show') && openedMenuAdherentLink.classList.add('show')
        }
      }
    }
  }); 

  document.querySelectorAll('ul.sub-menu').forEach(el => el.classList.contains('show-mobile-sub-menu') ? el.classList.remove('show-mobile-sub-menu') : '' )
  returnBtn.classList.contains('show') && returnBtn.classList.remove('show')
  searchForm.classList.contains('hide') && searchForm.classList.remove('hide')
  !openedMenuAdherentLink.classList.contains('show') && openedMenuAdherentLink.classList.add('show')
}


// WEBPACK FOOTER //
// ./scripts/responsive-menu.js